import { PageLayout } from '../components/Layout/PageLayout';
import { CubeGame } from '../components/CubeGame/CubeGame';
import { CubeHero } from '../components/CubeGame/CubeHero';

export function CubesPage() {
  return (
    <PageLayout
      hero={<CubeHero />}
      game={<CubeGame />}
    />
  );
}